import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Register from '../views/Register.vue'
import Login from '../views/Login.vue'
import Browse from '../views/Browse.vue'
import Dashboard from '../views/Dashboard.vue'
import Create from '../views/Create.vue'
import Library from '../views/Library.vue'
import Settings from '../views/Settings.vue'
import Legal from '../views/Legal.vue'
import ChangePassword from '../views/ChangePassword.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import AdminPanel from '../views/AdminPanel.vue'
import Created from '../views/Created.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/created',
    name: 'created',
    component: Created,
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/browse',
    name: 'browse',
    component: Browse,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
  },
  {
    path: '/library',
    name: 'library',
    component: Library,
  },
  {
    path: '/create',
    name: 'create',
    component: Create,
    props: (route) => ({
      ...route.params,
    }),
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
  },
  {
    path: '/legal',
    name: 'legal',
    component: Legal,
  },
  {
    path: '/changepassword',
    name: 'changepassword',
    component: ChangePassword,
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: ForgotPassword,
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminPanel,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
